<template>
    <div class="fixed bottom-20 right-6 z-[2147483647]" :class="{ 'hidden sm:block': !isBeaconOpen }">
        <AppButtonCircle
            :icon="isBeaconOpen ? 'fa-chevron-down' : 'fa-question'"
            buttonType="Primary"
            @click="toggleBeacon"
        />
    </div>
</template>
<script setup lang="ts">
import { onMounted, onUnmounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useEventParticipantStore } from "@/store/EventParticipant";
import { storeToRefs } from "pinia";
import AppButtonCircle from "@/components/AppButtonCircle.vue";

const route = useRoute();
const { isInEvent } = storeToRefs(useEventParticipantStore());
const isBeaconOpen = ref(false);
onMounted(() => {
    Beacon("on", "close", () => {
        isBeaconOpen.value = false;
    });
    Beacon("on", "open", () => {
        isBeaconOpen.value = true;
        const config = {
            hideFABOnMobile: true,
            hideFABLabelOnMobile: true,
            mode: "neutral",
            messaging: { chatEnabled: true },
            display: {
                style: "manual",
                horizontalMobileOffset: 20,
                verticalMobileOffset: 0,
                horizontalOffset: 20,
                verticalOffset: 125,
                zIndex: 2147483648,
            },
        };
        if ((isInEvent.value && (route.name === "Home" || route.name === "")) ||
            route.name === "RegisteredEvent" ||
            route.name === "RegisteredEventLite" ||
            route.name === "Leaderboard" ||
            route.name === "LeaderboardLite") {
            config.messaging.chatEnabled = false;
            Beacon("config", config);
        } else {
            Beacon("config", config);
        }
    });
});

onUnmounted(() => {
    Beacon("off", "open");
    Beacon("off", "close");
});

const toggleBeacon = () => {
    Beacon("toggle");
};
</script>
